<div class="dropdown-container">
  @if (!title) {
    <button
      id="dropdown-toggle"
      mat-icon-button
      [matMenuTriggerFor]="menu"
      [disabled]="disabled"
    >
      @if (icon && iconType === 'svg') {
        <mat-icon [svgIcon]="icon"></mat-icon>
      } @else if (icon) {
        <mat-icon>{{ icon }}</mat-icon>
      }
    </button>
  } @else {
    <button
      id="dropdown-toggle"
      mat-button
      [class.mat-mdc-raised-button]="buttonStyle === 'raised'"
      [class.mat-mdc-unelevated-button]="buttonStyle === 'unelevated'"
      [class.mat-mdc-outlined-button]="buttonStyle === 'outlined'"
      [class.mat-primary]="buttonColor === 'primary'"
      [class.suffix-icon]="iconPlacement === 'suffix'"
      color="primary"
      [matMenuTriggerFor]="menu"
      [disabled]="disabled"
    >
      @if (icon && iconType === 'svg') {
        <mat-icon class="button-icon" [svgIcon]="icon"></mat-icon>
      } @else if (icon) {
        <mat-icon class="button-icon">{{ icon }}</mat-icon>
      }
      <span class="button-content">{{ title }}</span>
    </button>
  }
  <mat-menu #menu="matMenu">
    @for (option of options; track option.label) {
      <button mat-menu-item (click)="onOptionClick(option)">
        @if (option.icon && option.iconType === 'svg') {
          <mat-icon class="button-icon" [svgIcon]="option.icon"></mat-icon>
        } @else if (option.icon) {
          <mat-icon class="button-icon">{{ option.icon }}</mat-icon>
        }
        <span>{{ option.label | translate }}</span>
      </button>
    }
  </mat-menu>
</div>
